export default __webpack_public_path__ + "static/media/avatar-circle.6fa3c129.svg";